<template>
  <b-modal
    ref="semContratante"
    :title="isSemChecklist ? 'Aprovação da proposta' : 'Informe os dados abaixo para emissão e envio de boleto e NFs'"
    size="xl"
    :dialog-class="'alteracao-tamanho-contratante'"
    :modal-class="'center-modal-contratante'"
    no-close-on-backdrop
    no-close-on-esc
    @hide="limparCampos"
  >
    <div v-if="isSemChecklist">
      <b-row class="h-100 m-0 row-split-content">
        <b-col
          cols="12"
          :lg="sidebarAberta ? 8 : 12"
          class="pdf-viewer-container p-0"
        >
          <div class="pdf-toolbar">
            <b-button
              variant="outline-primary"
              size="sm"
              class="mr-1"
              @click="toggleSidebar"
            >
              {{ sidebarAberta ? 'Ocultar serviços' : 'Mostrar serviços' }}
            </b-button>

            <b-button
              variant="primary"
              size="sm"
              class="mr-1"
              @click="aprovarSemChecklist"
            >
              Aprovar proposta
            </b-button>

            <b-button
              variant="outline-danger"
              size="sm"
              class="mr-1"
              @click="abrirJustificativa"
            >
              Recusar proposta
            </b-button>

            <b-button
              variant="link"
              size="sm"
              class="text-muted"
              @click="$refs.semContratante.hide()"
            >
              Cancelar
            </b-button>
          </div>

          <div class="pdf-placeholder">
            <div style="width:100%;">
              <iframe
                v-if="pdfViewerUrl"
                :src="pdfViewerUrl"
                style="width:100%; height:70vh; border:0;"
                frameborder="0"
              />
              <div
                v-else
                class="text-center text-muted mt-5 pt-5"
              >
                <h3 class="mb-2">
                  📄
                </h3>
                <h5>Visualização da Proposta Comercial</h5>
                <p>O arquivo PDF será carregado aqui.</p>
                <small>(Carregando...)</small>
              </div>
            </div>
          </div>
        </b-col>

        <b-col
          v-if="sidebarAberta"
          cols="12"
          lg="4"
          class="selection-sidebar"
        >
          <div class="aviso mt-2">
            <p>Serviços selecionados na proposta:</p>
          </div>

          <div class="servicos-list">
            <div v-if="servicosSelecionados && servicosSelecionados.length > 0">
              <b-list-group>
                <b-list-group-item
                  v-for="srv in servicosSelecionados"
                  :key="srv.id"
                  class="d-flex justify-content-between align-items-center"
                >
                  <span>{{ srv.nome }}</span>
                </b-list-group-item>
              </b-list-group>
            </div>

            <div
              v-else
              class="text-muted font-small-3"
            >
              Nenhum serviço encontrado.
            </div>

            <div
              v-if="servicosAdicionais && servicosAdicionais.length > 0"
              class="mt-2"
            >
              <div class="aviso">
                <p>Serviços adicionais:</p>
              </div>
              <b-list-group>
                <b-list-group-item
                  v-for="srv in servicosAdicionais"
                  :key="srv.id"
                  class="d-flex justify-content-between align-items-center"
                >
                  <span>{{ srv.nome }}</span>
                </b-list-group-item>
              </b-list-group>
            </div>
          </div>
        </b-col>
      </b-row>

      <justificativa-proposta-modal
        v-if="mostrarJustificativa"
        :proposta-recusada="true"
        @hidden="rejeitarProposta"
        @cancelar="mostrarJustificativa = false"
      />
    </div>

    <validation-observer
      v-else
      ref="validacao"
    >
      <div class="row">
        <div class="col-12 col-md-6 col-lg-2">
          <b-form-group label="Tipo de inscrição">
            <b-select
              ref="tipoInscricao"
              v-model="dadosContratante.tipoInscricaoEmpresa"
              :options="['CNPJ','CPF']"
              @change="limparDeterminadosCampos"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <b-form-group label="Informe a inscrição">
            <validation-provider
              #default="{ errors }"
              :rules="'required'"
              :name="'Inscrição'"
            >
              <b-input-group>
                <masked-input
                  ref="cadastroFederal"
                  v-model="dadosContratante.inscricao"
                  :mask="mascaraCadFederal"
                  class="form-control"
                />
                <b-input-group-append>
                  <b-button
                    v-b-tooltip.hover
                    title="Busca dados"
                    variant="primary"
                    @click="buscarDados(dadosContratante)"
                  >
                    <feather-icon
                      v-if="dadosContratante.buscado"
                      icon="CheckIcon"
                    />
                    <feather-icon
                      v-else
                      icon="SearchIcon"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <small
                v-if="dadosContratante.erroNavegacao"
                class="text-danger"
              >Não foi possível concluir a busca de dados na RFB, verifique o CNPJ informado e tente novamente!</small>
              <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </div>
        <div class="col-12 col-lg-7">
          <b-form-group :label="dadosContratante.tipoInscricaoEmpresa === 'CPF' ? 'Nome' : 'Razão Social'">
            <validation-provider
              #default="{ errors }"
              :rules="'required'"
              :name="dadosContratante.tipoInscricaoEmpresa === 'CPF' ? 'Nome' : 'Razão Social'"
            >
              <b-input v-model="dadosContratante.nomeRazaoSocial" />
              <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </div>
      </div>

      <div>
        <div
          v-if="dadosContratante.tipoInscricaoEmpresa === 'CNPJ'"
          class="row mt-50"
        >
          <div class="col">
            <b-form-group label="Nome Fantasia">
              <b-input v-model="dadosContratante.nomeFantasia" />
            </b-form-group>
          </div>
        </div>

        <div
          v-if="dadosContratante.tipoInscricaoEmpresa === 'CNPJ'"
          class="row mt-50"
        >
          <div class="col-12 col-md-12 col-lg-5">
            <legend class="col-form-label  pt-0">
              Optante pelo Simples Nacional
            </legend>
            <validation-provider
              #default="{ errors }"
              :rules="'required'"
              :name="'Simples Nacional'"
            >
              <b-select
                v-model="dadosContratante.simplesNacional"
                name="filtroDataPesquisa"
                class="search-items"
              >
                <option
                  v-for="(cert, index) in simplesNacional"
                  :key="index"
                  :value="cert.value"
                >
                  {{ cert.text }}
                </option>
              </b-select>
              <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
            </validation-provider>
          </div>
          <div class="col-12 col-md-12 col-lg-7">
            <telefone-celular :value="dadosContratante.telefoneContato" />
          </div>
        </div>
      </div>

      <div class="row mt-50">
        <div class="col">
          <email-input
            :value="dadosContratante.emailsBoletosNFs"
            :require="true"
            @input="adicionarEmail($event)"
          />
        </div>
        <div
          v-if="dadosContratante.tipoInscricaoEmpresa === 'CPF'"
          class="col-12 col-md-12 col-lg-5"
        >
          <telefone-celular :value="dadosContratante.telefoneContato" />
        </div>
      </div>

      <div :class="'row mt-50'">
        <div class="col-12 col-md-6 col-lg-3">
          <cep-input
            :value="dadosContratante.cep"
            :externo="true"
            @atualizar-endereco="enderecoBuscado"
          />
        </div>
        <b-form-group
          label="Endereço"
          class="col-12 col-md-6 col-lg-6"
        >
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'endereço'"
          >
            <b-form-input v-model="dadosContratante.logradouro" />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Número"
          class="col-12 col-md-6 col-lg-3"
        >
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Número'"
          >
            <b-form-input
              v-model="dadosContratante.numero"
              @keypress="isNumber($event)"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
      </div>

      <div class="row mt-50">
        <b-form-group
          label="Complemento"
          class="col-12 col-md-6 col-lg-3"
        >
          <b-form-input v-model="dadosContratante.complemento" />
        </b-form-group>
        <b-form-group
          label="Bairro"
          class="col-12 col-md-6 col-lg-4"
        >
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Bairro'"
          >
            <b-form-input v-model="dadosContratante.bairro" />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
        <div class="col-12 col-md-6 col-lg-3">
          <legend class="col-form-label pt-0">
            Cidade
          </legend>
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Cidade'"
          >
            <municipio-select
              v-model="dadosContratante.cidade"
              :externo="true"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <legend class="col-form-label pt-0">
            Estado
          </legend>
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Estado'"
          >
            <estado-select
              v-model="dadosContratante.uf"
              :externo="true"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </div>
      </div>
    </validation-observer>

    <template #modal-footer>
      <div
        v-if="!isSemChecklist"
        class="row container-button-contratante"
      >
        <div class="col-12 col-md-12 col-lg-8">
          <b-btn
            style="width: 100%;"
            variant="primary"
            @click="aprovarProposta"
          >
            Confirmar aprovação da proposta
          </b-btn>
        </div>
        <div class="col-12 col-md-12 col-lg-4">
          <b-btn
            style="width: 100%;"
            variant="danger"
            class="btn-cancelar-contratante"
            @click="$refs.semContratante.hide()"
          >
            Cancelar
          </b-btn>
        </div>
      </div>
    </template>

    <loading
      :is-loading="isLoading"
      :show-cancel-button="false"
      :show-message="'Aguarde estamos buscando os dados no sistema!'"
    />
  </b-modal>
</template>

<style lang="scss">
.container-button-contratante{
  width: 34rem;
}
.alteracao-tamanho-contratante {
  width: 1400px !important;
  max-width: 95vw !important;
}

.center-modal-contratante {
  display: flex !important;
  justify-content: center !important;
  align-items: center;
}

.row-split-content {
  min-height: 70vh;
}

.pdf-viewer-container {
  background: #fff;
}

.pdf-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0.75rem;
  border-bottom: 1px solid #e7e7e7;
  align-items: center;
}

.selection-sidebar {
  border-left: 1px solid #e7e7e7;
  padding: 1rem;
}

.aviso {
  text-align: left;
  font-size: 13px;
  background-color: lightgoldenrodyellow;
  padding: 0.5rem;
  margin-bottom: 1rem;
  border-radius: 0.3rem;
  p { margin: 0; }
}

@media screen and (max-width: 768px) {
  .alteracao-tamanho-contratante {
    max-width: 95vw !important;
    height: 100vh;
  }
}

@media screen and (max-width: 991px) {
  .btn-cancelar-contratante{
    margin-top: 1rem;
  }
  .container-button-contratante{
    width: 100%;
  }
}
</style>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { getUserInfo } from '@/auth/utils'
import api from '@/app-modulo/comercial/portal-proposta/shared/services/api'

export default {
  name: 'DadosContratanteExterno',
  components: {
    ValidationProvider,
    ValidationObserver,
    EstadoSelect: () => import('@/shared/components/estado-select/EstadoSelect.vue'),
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
    MunicipioSelect: () => import('@/shared/components/municipio-select/MunicipioSelect.vue'),
    EmailInput: () => import('@/@pilar/components/email-input/EmailInput.vue'),
    CepInput: () => import('@/@pilar/components/cep-input/CepInput.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
    JustificativaPropostaModal: () => import('@/app-modulo/comercial/portal-proposta/shared/components/justificativa-proposta/JustificaProposta.vue'),
  },
  props: {
    proposta: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dadosContratante: {
        tipoInscricaoEmpresa: 'CPF',
        nomeRazaoSocial: null,
        nomeFantasia: null,
        inscricao: null,
        simplesNacional: null,
        emailsBoletosNFs: [],
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
        buscado: false,
      },
      isLoading: false,
      invalidTags: [],
      duplicateTags: [],
      simplesNacional: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],
      pacotes: [],
      servicos: [],
      pdfUrl: null,
      mostrarJustificativa: false,
      sidebarAberta: true,
    }
  },
  computed: {
    propostaObj() {
      return this.proposta && typeof this.proposta === 'object' ? this.proposta : {}
    },
    isSemChecklist() {
      return this.propostaObj.tipoProposta === 'semchecklist'
    },
    pdfViewerUrl() {
      if (!this.pdfUrl) return null
      return `${this.pdfUrl}#navpanes=0&pagemode=none&view=FitH`
    },
    servicosSelecionados() {
      const lista = []
      const proposta = this.propostaObj

      if (proposta.propostaPacotes && proposta.propostaPacotes.length > 0 && proposta.propostaPacotes[0] && proposta.propostaPacotes[0].servicos) {
        proposta.propostaPacotes[0].servicos.forEach(s => {
          if (s) lista.push({ id: s.id, nome: s.nome })
        })
      } else if (this.pacotes && this.pacotes.length > 0 && this.pacotes[0] && this.pacotes[0].servicos) {
        this.pacotes[0].servicos.forEach(s => {
          if (s) lista.push({ id: s.id, nome: s.nome })
        })
      }

      if (proposta.servico && proposta.servico.length > 0) {
        proposta.servico
          .filter(s => !s.servicoAdicional)
          .forEach(s => {
            const nome = s && s.servico ? s.servico.nome : null
            if (nome) lista.push({ id: s.id, nome })
          })
      }

      const seen = new Set()
      return lista.filter(s => {
        const key = `${s.id || ''}-${s.nome || ''}`.trim()
        if (!key || seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    servicosAdicionais() {
      const lista = []
      const proposta = this.propostaObj

      if (this.servicos && this.servicos.length > 0) {
        this.servicos.forEach(s => {
          let nome = null
          if (s && s.servico && s.servico.nome) {
            nome = s.servico.nome
          } else if (s && s.nome) {
            nome = s.nome
          }
          if (nome) lista.push({ id: s.id, nome })
        })
      }

      if (proposta.servico && proposta.servico.length > 0) {
        proposta.servico
          .filter(s => !!s.servicoAdicional)
          .forEach(s => {
            const nome = s && s.servico ? s.servico.nome : null
            if (nome) lista.push({ id: s.id, nome })
          })
      }

      const seen = new Set()
      return lista.filter(s => {
        const key = `${s.id || ''}-${s.nome || ''}`.trim()
        if (!key || seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
  },
  beforeDestroy() {
    if (this.pdfUrl && this.pdfUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.pdfUrl)
      this.pdfUrl = null
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarAberta = !this.sidebarAberta
    },
    adicionarEmail(value) {
      this.dadosContratante.emailsBoletosNFs = value
    },
    async show() {
      if (this.isSemChecklist) {
        this.sidebarAberta = true
        await this.carregarPacotes()
        await this.carregarPdf()
        this.$refs.semContratante.show()
        return
      }
      this.dadosContratante.emailsBoletosNFs.push(getUserInfo().email)
      this.$refs.semContratante.show()
    },
    mascaraCadFederal() {
      if (this.dadosContratante.tipoInscricaoEmpresa === 'CPF') {
        return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
      }
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    mudarParaLowerCase(value) {
      const emails = []
      value.forEach(each => emails.push(each.toLowerCase()))
      this.dadosContratante.emailsBoletosNFs = emails
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return erro.replace('The', '').replace('field is required', 'é um campo obrigatório')
      }
      return erro
    },
    aprovarProposta() {
      this.$refs.validacao.validate()
        .then(result => {
          if (result) {
            this.$emit('aprovado', this.dadosContratante)
            this.$refs.semContratante.hide()
          } else {
            this.$erro('Preencha os campos obrigatórios!')
          }
        })
    },
    aprovarSemChecklist() {
      this.$emit('aprovado', { naoAprovar: false, justificativa: '' })
      this.$refs.semContratante.hide()
    },
    abrirJustificativa() {
      this.mostrarJustificativa = true
    },
    rejeitarProposta(justificativaRecusar) {
      this.mostrarJustificativa = false
      this.$emit('aprovado', { naoAprovar: true, justificativa: justificativaRecusar || '' })
      this.$refs.semContratante.hide()
    },
    limparCampos() {
      if (this.pdfUrl && this.pdfUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.pdfUrl)
      }
      this.pdfUrl = null
      this.pacotes = []
      this.servicos = []
      this.mostrarJustificativa = false
      this.sidebarAberta = true

      this.dadosContratante = {
        tipoInscricaoEmpresa: 'CPF',
        nomeRazaoSocial: null,
        nomeFantasia: null,
        inscricao: null,
        emailsBoletosNFs: [],
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
      }
    },
    enderecoBuscado(value) {
      this.$set(this.dadosContratante, 'logradouro', value.logradouro)
      this.$set(this.dadosContratante, 'bairro', value.bairro)
      this.$set(this.dadosContratante, 'complemento', value.complemento)
      this.$set(this.dadosContratante, 'uf', value.uf)
      this.$set(this.dadosContratante, 'cidade', value.cidade)
      this.$set(this.dadosContratante, 'cep', value.cep)
    },
    isNumber(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[0-9]+$/.test(char)) return true
      e.preventDefault()
      return false
    },
    buscarDados(dados) {
      this.dadosContratante.erroNavegacao = false
      this.isLoading = true
      api.buscaPropostaContratante(dados)
        .then(payload => {
          if (payload.data) {
            const { data } = payload
            this.dadosContratante = data
            if (!this.dadosContratante.emailsBoletosNFs || (this.dadosContratante.emailsBoletosNFs && this.dadosContratante.emailsBoletosNFs.length === 0)) {
              this.dadosContratante.emailsBoletosNFs = []
              this.dadosContratante.emailsBoletosNFs.push(getUserInfo().email)
            }
          } else if (dados.tipoInscricaoEmpresa === 'CPF') {
            this.$erro('CPF não encontrado em nossa base de dados, preencha os campos manualmente.')
          }

          this.dadosContratante.buscado = true
        })
        .catch(err => {
          this.$handleError(err)
          throw err
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    limparDeterminadosCampos(value) {
      this.dadosContratante = {
        nomeRazaoSocial: null,
        nomeFantasia: null,
        inscricao: null,
        emailsBoletosNFs: [],
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
      }
      this.$set(this.dadosContratante, 'tipoInscricaoEmpresa', value)
    },
    carregarPacotes() {
      const proposta = this.propostaObj
      if (proposta.id > 0) {
        return api.getPacotesEServicos(proposta.id)
          .then(payload => {
            const { pacotes, servicos } = payload.data
            this.pacotes = pacotes || []
            this.servicos = servicos || []
          })
      }
      return Promise.resolve()
    },
    async carregarPdf() {
      const proposta = this.propostaObj
      const propostaRelatorioId = proposta.propostaIdVinculada || proposta.propostaId || null
      if (!propostaRelatorioId) return

      try {
        const res = await api.gerarTokenVisualizacao(propostaRelatorioId)
        const token = res.data || null
        const response = await api.getRelatorioProposta(propostaRelatorioId, token)
        const payload = response?.data
        const remoteUrl = typeof payload === 'string' ? payload.trim() : null

        if (remoteUrl) {
          if (this.pdfUrl && this.pdfUrl.startsWith('blob:')) URL.revokeObjectURL(this.pdfUrl)
          this.pdfUrl = remoteUrl
          return
        }

        if (payload && payload.byteLength > 0) {
          const blob = new Blob([payload], { type: 'application/pdf' })
          if (this.pdfUrl && this.pdfUrl.startsWith('blob:')) URL.revokeObjectURL(this.pdfUrl)
          this.pdfUrl = URL.createObjectURL(blob)
        }
      } catch (err) {
        const resolved = this.$resolveError(err)
        const msg = resolved.detail || resolved.title || err?.message || ''
        this.$erro(`Não foi possível carregar a Proposta em PDF: ${msg}`)
      }
    },
  },
}
</script>
